import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Sendbird from './SendbirdProvider.js';
import { u as useMediaQueryContext } from './MediaQueryContext-d6110905.js';
import ChannelList from './ChannelList.js';
import Channel from './Channel.js';
import ChannelSettings from './ChannelSettings.js';
import MessageSearchPannel from './MessageSearch.js';
import Thread from './Thread.js';
import { GroupChannelHandler } from '@sendbird/chat/groupChannel';
import useSendbirdStateContext from './useSendbirdStateContext.js';
import { u as uuidv4 } from './uuid-717930b4.js';
import { u as useVoicePlayerContext, A as ALL } from './index-fa5b2b8c.js';
import { V as VOICE_RECORDER_DEFAULT_MAX, a as VOICE_RECORDER_DEFAULT_MIN } from './consts-fa6ab3c0.js';
import './_rollupPluginBabelHelpers-05128ded.js';
import './withSendbird.js';
import 'css-vars-ponyfill';
import './index.module-4f1cd64e.js';
import './actionTypes-ba87a2c9.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import './index-579ca9d7.js';
import './utils/message/getOutgoingMessageState.js';
import '@sendbird/uikit-tools';
import './VoiceRecorder/context.js';
import './LocalizationContext-a82461b5.js';
import './stringSet-b60e9529.js';
import './index-6add7940.js';
import './ui/Modal.js';
import 'react-dom';
import './index-a9101009.js';
import './ui/Button.js';
import './index-6420013c.js';
import './ui/Icon.js';
import './ui/IconButton.js';
import './resolvedReplyType-9d00a3db.js';
import './ChannelListProvider-e9a09891.js';
import './topics-eb548880.js';
import './utils-e0c7329c.js';
import './UserProfileContext-f3f446d2.js';
import './ChannelList/components/ChannelListUI.js';
import './ChannelList/components/ChannelListHeader.js';
import './ui/Avatar.js';
import './ui/ImageRenderer.js';
import './ChannelList/components/AddChannel.js';
import './CreateChannel.js';
import './CreateChannel/components/CreateChannelUI.js';
import './CreateChannelProvider-47a1c523.js';
import './sendbirdSelectors.js';
import './CreateChannel/components/InviteUsers.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './ui/ContextMenu.js';
import './ui/SortByRow.js';
import './CreateChannel/components/SelectChannelType.js';
import './ChannelList/components/ChannelPreview.js';
import './ui/ChannelAvatar.js';
import './utils-7f5e872b.js';
import './ui/Badge.js';
import './index-ac0b2d20.js';
import './index-ccef08fe.js';
import './ui/Loader.js';
import './index-f879f6ef.js';
import './index-ad50e2c0.js';
import './ui/MentionUserLabel.js';
import './consts-b4cb83cf.js';
import './ui/TextButton.js';
import './color-91e43dce.js';
import './Channel/components/TypingIndicator.js';
import './ChannelProvider-5dcbee7b.js';
import './const-72f012b6.js';
import './compareIds-2e50e905.js';
import '@sendbird/chat/message';
import './useLongPress-12280c78.js';
import './ChannelList/components/ChannelPreviewAction.js';
import './EditUserProfile.js';
import './index-10dad19d.js';
import './ui/Input.js';
import './index-2cfab646.js';
import './Channel/components/ChannelUI.js';
import './ui/ConnectionStatus.js';
import './Channel/components/ChannelHeader.js';
import './utils-b571dc44.js';
import './Channel/components/MessageList.js';
import './Channel/components/Message.js';
import './Channel/components/SuggestedMentionList.js';
import './const-3a34a127.js';
import './ThreadProvider-cf357120.js';
import './Thread/context/types.js';
import './ui/DateSeparator.js';
import './ui/MessageInput.js';
import 'dompurify';
import './consts-7693b8d3.js';
import './consts-9469111b.js';
import './tokenize-c718324d.js';
import './ui/MessageContent.js';
import './ui/MessageItemMenu.js';
import './types-95cfd227.js';
import './ui/MessageItemReactionMenu.js';
import './ui/ReactionButton.js';
import './ui/EmojiReactions.js';
import './ui/ReactionBadge.js';
import './ui/BottomSheet.js';
import './ui/Tooltip.js';
import './ui/TooltipWrapper.js';
import './Message/context.js';
import './ui/AdminMessage.js';
import './ui/TextMessageItemBody.js';
import './index-a2bb2783.js';
import './ui/MentionLabel.js';
import './ui/LinkLabel.js';
import './ui/FileMessageItemBody.js';
import './ui/ThumbnailMessageItemBody.js';
import './ui/OGMessageItemBody.js';
import './ui/UnknownMessageItemBody.js';
import './ui/QuoteMessage.js';
import './index-86294a68.js';
import './ui/ThreadReplies.js';
import './ui/VoiceMessageItemBody.js';
import './ui/ProgressBar.js';
import './VoicePlayer/useVoicePlayer.js';
import './ui/PlaybackTime.js';
import './Channel/components/FileViewer.js';
import './Channel/components/RemoveMessageModal.js';
import './index-dd5a8777.js';
import './useDirtyGetMentions-dffd4046.js';
import './Channel/components/UnreadCount.js';
import './Channel/components/FrozenNotification.js';
import './Channel/components/MessageInput.js';
import './ui/QuoteMessageInput.js';
import './VoiceMessageInputWrapper-43163d7f.js';
import './VoiceRecorder/useVoiceRecorder.js';
import './index-090cbf21.js';
import './ChannelSettings/components/ChannelSettingsUI.js';
import './ChannelSettings/context.js';
import './ChannelSettings/components/ChannelProfile.js';
import './ChannelSettings/components/EditDetailsModal.js';
import './ChannelSettings/components/ModerationPanel.js';
import './ui/Accordion.js';
import './ui/AccordionGroup.js';
import './context-6be2d352.js';
import './ui/Toggle.js';
import './ChannelSettings/components/UserListItem.js';
import './MemberList-5d8a0a9b.js';
import './ChannelSettings/components/LeaveChannel.js';
import './ChannelSettings/components/UserPanel.js';
import './MessageSearch/components/MessageSearchUI.js';
import './MessageSearch/context.js';
import './ui/MessageSearchItem.js';
import './ui/MessageSearchFileItem.js';
import './Thread/components/ThreadUI.js';
import './Thread/components/ParentMessageInfo.js';
import './RemoveMessageModal-2adc29ce.js';
import './Thread/components/ParentMessageInfoItem.js';
import './ui/FileViewer.js';
import './Thread/components/ThreadHeader.js';
import './Thread/components/ThreadList.js';
import './Thread/components/ThreadListItem.js';
import 'date-fns';
import './Thread/components/ThreadMessageInput.js';
var DesktopLayout = function DesktopLayout(props) {
  var isReactionEnabled = props.isReactionEnabled,
    replyType = props.replyType,
    isMessageGroupingEnabled = props.isMessageGroupingEnabled,
    allowProfileEdit = props.allowProfileEdit,
    showSearchIcon = props.showSearchIcon,
    onProfileEditSuccess = props.onProfileEditSuccess,
    disableAutoSelect = props.disableAutoSelect,
    currentChannel = props.currentChannel,
    setCurrentChannel = props.setCurrentChannel,
    showSettings = props.showSettings,
    setShowSettings = props.setShowSettings,
    showSearch = props.showSearch,
    setShowSearch = props.setShowSearch,
    highlightedMessage = props.highlightedMessage,
    setHighlightedMessage = props.setHighlightedMessage,
    startingPoint = props.startingPoint,
    setStartingPoint = props.setStartingPoint,
    showThread = props.showThread,
    setShowThread = props.setShowThread,
    threadTargetMessage = props.threadTargetMessage,
    setThreadTargetMessage = props.setThreadTargetMessage;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    animatedMessageId = _useState2[0],
    setAnimatedMessageId = _useState2[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-app__wrap"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-app__channellist-wrap"
  }, /*#__PURE__*/React__default.createElement(ChannelList, {
    allowProfileEdit: allowProfileEdit,
    activeChannelUrl: currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url,
    onProfileEditSuccess: onProfileEditSuccess,
    disableAutoSelect: disableAutoSelect,
    onChannelSelect: function onChannelSelect(channel) {
      setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint(null);
      setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null);
      if (channel) {
        setCurrentChannel(channel);
      } else {
        setCurrentChannel(null);
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "\n          ".concat(showSettings ? 'sendbird-app__conversation--settings-open' : '', "\n          ").concat(showSearch ? 'sendbird-app__conversation--search-open' : '', "\n          sendbird-app__conversation-wrap\n        ")
  }, /*#__PURE__*/React__default.createElement(Channel, {
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    onChatHeaderActionClick: function onChatHeaderActionClick() {
      setShowSearch(false);
      setShowThread(false);
      setShowSettings(!showSettings);
    },
    onSearchClick: function onSearchClick() {
      setShowSettings(false);
      setShowThread(false);
      setShowSearch(!showSearch);
    },
    onReplyInThread: function onReplyInThread(_ref) {
      var message = _ref.message; // parent message
      setShowSettings(false);
      setShowSearch(false);
      if (replyType === 'THREAD') {
        setThreadTargetMessage(message);
        setShowThread(true);
      }
    },
    onQuoteMessageClick: function onQuoteMessageClick(_ref2) {
      var message = _ref2.message; // thread message
      setShowSettings(false);
      setShowSearch(false);
      if (replyType === 'THREAD') {
        setThreadTargetMessage(message);
        setShowThread(true);
      }
    },
    onMessageAnimated: function onMessageAnimated() {
      setAnimatedMessageId(null);
    },
    onMessageHighlighted: function onMessageHighlighted() {
      setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null);
    },
    showSearchIcon: showSearchIcon,
    startingPoint: startingPoint,
    animatedMessage: animatedMessageId,
    highlightedMessage: highlightedMessage,
    isReactionEnabled: isReactionEnabled,
    replyType: replyType,
    isMessageGroupingEnabled: isMessageGroupingEnabled
  })), showSettings && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-app__settingspanel-wrap"
  }, /*#__PURE__*/React__default.createElement(ChannelSettings, {
    className: "sendbird-channel-settings",
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    onCloseClick: function onCloseClick() {
      setShowSettings(false);
    }
  })), showSearch && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-app__searchpanel-wrap"
  }, /*#__PURE__*/React__default.createElement(MessageSearchPannel, {
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    onResultClick: function onResultClick(message) {
      if (message.messageId === highlightedMessage) {
        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(null);
        setTimeout(function () {
          setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(message.messageId);
        });
      } else {
        setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint(message.createdAt);
        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(message.messageId);
      }
    },
    onCloseClick: function onCloseClick() {
      setShowSearch(false);
    }
  })), showThread && /*#__PURE__*/React__default.createElement(Thread, {
    className: "sendbird-app__thread",
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    message: threadTargetMessage,
    onHeaderActionClick: function onHeaderActionClick() {
      setShowThread(false);
    },
    onMoveToParentMessage: function onMoveToParentMessage(_ref3) {
      var message = _ref3.message,
        channel = _ref3.channel;
      if ((channel === null || channel === void 0 ? void 0 : channel.url) !== (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
        setCurrentChannel(channel);
      }
      if ((message === null || message === void 0 ? void 0 : message.messageId) !== animatedMessageId) {
        setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint(message === null || message === void 0 ? void 0 : message.createdAt);
      }
      setTimeout(function () {
        setAnimatedMessageId(message === null || message === void 0 ? void 0 : message.messageId);
      }, 500);
    }
  }));
};
var PANELS = /*#__PURE__*/function (PANELS) {
  PANELS["CHANNEL_LIST"] = "CHANNEL_LIST";
  PANELS["CHANNEL"] = "CHANNEL";
  PANELS["CHANNEL_SETTINGS"] = "CHANNEL_SETTINGS";
  PANELS["MESSAGE_SEARCH"] = "MESSAGE_SEARCH";
  PANELS["THREAD"] = "THREAD";
  return PANELS;
}(PANELS || {});
var MobileLayout = function MobileLayout(props) {
  var _store$stores, _store$stores$sdkStor, _store$config;
  var replyType = props.replyType,
    isMessageGroupingEnabled = props.isMessageGroupingEnabled,
    allowProfileEdit = props.allowProfileEdit,
    isReactionEnabled = props.isReactionEnabled,
    showSearchIcon = props.showSearchIcon,
    onProfileEditSuccess = props.onProfileEditSuccess,
    currentChannel = props.currentChannel,
    setCurrentChannel = props.setCurrentChannel,
    highlightedMessage = props.highlightedMessage,
    setHighlightedMessage = props.setHighlightedMessage,
    startingPoint = props.startingPoint,
    setStartingPoint = props.setStartingPoint,
    threadTargetMessage = props.threadTargetMessage,
    setThreadTargetMessage = props.setThreadTargetMessage;
  var _useState3 = useState(PANELS.CHANNEL_LIST),
    _useState4 = _slicedToArray(_useState3, 2),
    panel = _useState4[0],
    setPanel = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    animatedMessageId = _useState6[0],
    setAnimatedMessageId = _useState6[1];
  var store = useSendbirdStateContext();
  var sdk = store === null || store === void 0 ? void 0 : (_store$stores = store.stores) === null || _store$stores === void 0 ? void 0 : (_store$stores$sdkStor = _store$stores.sdkStore) === null || _store$stores$sdkStor === void 0 ? void 0 : _store$stores$sdkStor.sdk;
  var userId = store === null || store === void 0 ? void 0 : (_store$config = store.config) === null || _store$config === void 0 ? void 0 : _store$config.userId;
  var _useVoicePlayerContex = useVoicePlayerContext(),
    pause = _useVoicePlayerContex.pause;
  var goToMessage = function goToMessage(message, timeoutCb) {
    setStartingPoint === null || setStartingPoint === void 0 ? void 0 : setStartingPoint((message === null || message === void 0 ? void 0 : message.createdAt) || null);
    setTimeout(function () {
      timeoutCb === null || timeoutCb === void 0 ? void 0 : timeoutCb((message === null || message === void 0 ? void 0 : message.messageId) || null);
    }, 500);
  };
  useEffect(function () {
    if (panel !== PANELS.CHANNEL) {
      goToMessage(null, function () {
        return setAnimatedMessageId(null);
      });
    }
  }, [panel]);
  useEffect(function () {
    var _sdk$groupChannel;
    var handlerId = uuidv4();
    if (sdk !== null && sdk !== void 0 && (_sdk$groupChannel = sdk.groupChannel) !== null && _sdk$groupChannel !== void 0 && _sdk$groupChannel.addGroupChannelHandler) {
      var _sdk$groupChannel2;
      var handler = new GroupChannelHandler({
        onUserBanned: function onUserBanned(groupChannel, user) {
          if (groupChannel.url === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) && (user === null || user === void 0 ? void 0 : user.userId) === userId) {
            setPanel(PANELS.CHANNEL_LIST);
          }
        },
        onChannelDeleted: function onChannelDeleted(channelUrl) {
          if (channelUrl === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url)) {
            setPanel(PANELS.CHANNEL_LIST);
          }
        },
        onUserLeft: function onUserLeft(groupChannel, user) {
          if (groupChannel.url === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) && (user === null || user === void 0 ? void 0 : user.userId) === userId) {
            setPanel(PANELS.CHANNEL_LIST);
          }
        }
      });
      sdk === null || sdk === void 0 ? void 0 : (_sdk$groupChannel2 = sdk.groupChannel) === null || _sdk$groupChannel2 === void 0 ? void 0 : _sdk$groupChannel2.addGroupChannelHandler(handlerId, handler);
    }
    return function () {
      var _sdk$groupChannel3, _sdk$groupChannel3$re;
      sdk === null || sdk === void 0 ? void 0 : (_sdk$groupChannel3 = sdk.groupChannel) === null || _sdk$groupChannel3 === void 0 ? void 0 : (_sdk$groupChannel3$re = _sdk$groupChannel3.removeGroupChannelHandler) === null || _sdk$groupChannel3$re === void 0 ? void 0 : _sdk$groupChannel3$re.call(_sdk$groupChannel3, handlerId);
    };
  }, [sdk]);

  // if currentChannel is changed while on Thread
  // then change panel type to CHANNEL
  useEffect(function () {
    if (panel === PANELS.THREAD) {
      setPanel(PANELS.CHANNEL);
    }
  }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sb_mobile"
  }, panel === PANELS.CHANNEL_LIST && /*#__PURE__*/React__default.createElement("div", {
    className: "sb_mobile__panelwrap"
  }, /*#__PURE__*/React__default.createElement(ChannelList, {
    onProfileEditSuccess: onProfileEditSuccess,
    onChannelSelect: function onChannelSelect(channel) {
      setCurrentChannel(channel);
      setPanel(PANELS.CHANNEL);
    },
    allowProfileEdit: allowProfileEdit
    // this condition must be true for mobile
    ,

    disableAutoSelect: true
  })), panel === PANELS.CHANNEL && /*#__PURE__*/React__default.createElement("div", {
    className: "sb_mobile__panelwrap"
  }, /*#__PURE__*/React__default.createElement(Channel, {
    replyType: replyType,
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    onSearchClick: function onSearchClick() {
      setPanel(PANELS.MESSAGE_SEARCH);
    },
    onBackClick: function onBackClick() {
      setPanel(PANELS.CHANNEL_LIST);
      pause(ALL);
    },
    isReactionEnabled: isReactionEnabled,
    showSearchIcon: showSearchIcon,
    isMessageGroupingEnabled: isMessageGroupingEnabled,
    startingPoint: startingPoint,
    animatedMessage: animatedMessageId,
    highlightedMessage: highlightedMessage,
    onChatHeaderActionClick: function onChatHeaderActionClick() {
      setPanel(PANELS.CHANNEL_SETTINGS);
    },
    onReplyInThread: function onReplyInThread(_ref) {
      var message = _ref.message;
      if (replyType === 'THREAD') {
        setPanel(PANELS.THREAD);
        setThreadTargetMessage(message);
      }
    },
    onQuoteMessageClick: function onQuoteMessageClick(_ref2) {
      var message = _ref2.message; // thread message
      if (replyType === 'THREAD') {
        setThreadTargetMessage(message);
        setPanel(PANELS.THREAD);
      }
    }
  })), panel === PANELS.CHANNEL_SETTINGS && /*#__PURE__*/React__default.createElement("div", {
    className: "sb_mobile__panelwrap"
  }, /*#__PURE__*/React__default.createElement(ChannelSettings, {
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    onCloseClick: function onCloseClick() {
      setPanel(PANELS.CHANNEL);
    },
    onLeaveChannel: function onLeaveChannel() {
      setPanel(PANELS.CHANNEL_LIST);
    }
  })), panel === PANELS.MESSAGE_SEARCH && /*#__PURE__*/React__default.createElement("div", {
    className: "sb_mobile__panelwrap"
  }, /*#__PURE__*/React__default.createElement(MessageSearchPannel, {
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    onCloseClick: function onCloseClick() {
      setPanel(PANELS.CHANNEL);
    },
    onResultClick: function onResultClick(message) {
      setPanel(PANELS.CHANNEL);
      goToMessage(message, function (messageId) {
        setHighlightedMessage === null || setHighlightedMessage === void 0 ? void 0 : setHighlightedMessage(messageId);
      });
    }
  })), panel === PANELS.THREAD && /*#__PURE__*/React__default.createElement("div", {
    className: "sb_mobile__panelwrap"
  }, /*#__PURE__*/React__default.createElement(Thread, {
    channelUrl: (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) || '',
    message: threadTargetMessage,
    onHeaderActionClick: function onHeaderActionClick() {
      setPanel(PANELS.CHANNEL);
      pause(ALL);
    },
    onMoveToParentMessage: function onMoveToParentMessage(_ref3) {
      var message = _ref3.message,
        channel = _ref3.channel;
      setCurrentChannel(channel);
      goToMessage(message, function (messageId) {
        setPanel(PANELS.CHANNEL);
        setAnimatedMessageId(messageId);
      });
    }
  })));
};
var AppLayout = function AppLayout(props) {
  var _props$replyType, _props$isReactionEnab, _props$showSearchIcon;
  var isMessageGroupingEnabled = props.isMessageGroupingEnabled,
    allowProfileEdit = props.allowProfileEdit,
    onProfileEditSuccess = props.onProfileEditSuccess,
    disableAutoSelect = props.disableAutoSelect,
    currentChannel = props.currentChannel,
    setCurrentChannel = props.setCurrentChannel;
  var globalStore = useSendbirdStateContext();
  var globalConfigs = globalStore === null || globalStore === void 0 ? void 0 : globalStore.config;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showThread = _useState8[0],
    setShowThread = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    threadTargetMessage = _useState0[0],
    setThreadTargetMessage = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showSettings = _useState10[0],
    setShowSettings = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showSearch = _useState12[0],
    setShowSearch = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    highlightedMessage = _useState14[0],
    setHighlightedMessage = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    startingPoint = _useState16[0],
    setStartingPoint = _useState16[1];
  var _useMediaQueryContext = useMediaQueryContext(),
    isMobile = _useMediaQueryContext.isMobile;
  /**
   * Below configs can be set via Dashboard UIKit config setting but as a lower priority than App props.
   * So need to be have fallback value \w global configs even though each prop values are undefined
   */
  var replyType = (_props$replyType = props.replyType) !== null && _props$replyType !== void 0 ? _props$replyType : globalConfigs === null || globalConfigs === void 0 ? void 0 : globalConfigs.replyType;
  var isReactionEnabled = (_props$isReactionEnab = props.isReactionEnabled) !== null && _props$isReactionEnab !== void 0 ? _props$isReactionEnab : globalConfigs === null || globalConfigs === void 0 ? void 0 : globalConfigs.isReactionEnabled;
  var showSearchIcon = (_props$showSearchIcon = props.showSearchIcon) !== null && _props$showSearchIcon !== void 0 ? _props$showSearchIcon : globalConfigs === null || globalConfigs === void 0 ? void 0 : globalConfigs.showSearchIcon;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isMobile ? /*#__PURE__*/React__default.createElement(MobileLayout, {
    replyType: replyType,
    showSearchIcon: showSearchIcon,
    isReactionEnabled: isReactionEnabled,
    isMessageGroupingEnabled: isMessageGroupingEnabled,
    allowProfileEdit: allowProfileEdit,
    onProfileEditSuccess: onProfileEditSuccess,
    currentChannel: currentChannel,
    setCurrentChannel: setCurrentChannel,
    highlightedMessage: highlightedMessage,
    setHighlightedMessage: setHighlightedMessage,
    startingPoint: startingPoint,
    setStartingPoint: setStartingPoint,
    threadTargetMessage: threadTargetMessage,
    setThreadTargetMessage: setThreadTargetMessage
  }) : /*#__PURE__*/React__default.createElement(DesktopLayout, {
    replyType: replyType,
    isReactionEnabled: isReactionEnabled,
    showSearchIcon: showSearchIcon,
    isMessageGroupingEnabled: isMessageGroupingEnabled,
    allowProfileEdit: allowProfileEdit,
    onProfileEditSuccess: onProfileEditSuccess,
    disableAutoSelect: disableAutoSelect,
    currentChannel: currentChannel,
    setCurrentChannel: setCurrentChannel,
    showThread: showThread,
    setShowThread: setShowThread,
    threadTargetMessage: threadTargetMessage,
    setThreadTargetMessage: setThreadTargetMessage,
    showSettings: showSettings,
    setShowSettings: setShowSettings,
    showSearch: showSearch,
    setShowSearch: setShowSearch,
    highlightedMessage: highlightedMessage,
    setHighlightedMessage: setHighlightedMessage,
    startingPoint: startingPoint,
    setStartingPoint: setStartingPoint
  }));
};

/**
 * This is a drop in Chat solution
 * Can also be used as an example for creating
 * default chat apps
 */
function App(props) {
  var appId = props.appId,
    userId = props.userId,
    accessToken = props.accessToken,
    customApiHost = props.customApiHost,
    customWebSocketHost = props.customWebSocketHost,
    breakpoint = props.breakpoint,
    theme = props.theme,
    userListQuery = props.userListQuery,
    nickname = props.nickname,
    profileUrl = props.profileUrl,
    dateLocale = props.dateLocale,
    _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    isReactionEnabled = props.isReactionEnabled,
    isMentionEnabled = props.isMentionEnabled,
    isVoiceMessageEnabled = props.isVoiceMessageEnabled,
    voiceRecord = props.voiceRecord,
    replyType = props.replyType,
    isMessageGroupingEnabled = props.isMessageGroupingEnabled,
    colorSet = props.colorSet,
    stringSet = props.stringSet,
    allowProfileEdit = props.allowProfileEdit,
    disableUserProfile = props.disableUserProfile,
    disableMarkAsDelivered = props.disableMarkAsDelivered,
    renderUserProfile = props.renderUserProfile,
    showSearchIcon = props.showSearchIcon,
    onProfileEditSuccess = props.onProfileEditSuccess,
    imageCompression = props.imageCompression,
    disableAutoSelect = props.disableAutoSelect,
    isTypingIndicatorEnabledOnChannelList = props.isTypingIndicatorEnabledOnChannelList,
    isMessageReceiptStatusEnabledOnChannelList = props.isMessageReceiptStatusEnabledOnChannelList,
    uikitOptions = props.uikitOptions;
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    currentChannel = _useState18[0],
    setCurrentChannel = _useState18[1];
  return /*#__PURE__*/React__default.createElement(Sendbird, {
    stringSet: stringSet,
    appId: appId,
    userId: userId,
    accessToken: accessToken,
    customApiHost: customApiHost,
    customWebSocketHost: customWebSocketHost,
    breakpoint: breakpoint,
    theme: theme,
    nickname: nickname,
    profileUrl: profileUrl,
    dateLocale: dateLocale,
    userListQuery: userListQuery,
    config: config,
    colorSet: colorSet,
    disableUserProfile: disableUserProfile,
    disableMarkAsDelivered: disableMarkAsDelivered,
    renderUserProfile: renderUserProfile,
    imageCompression: imageCompression,
    isReactionEnabled: isReactionEnabled,
    isMentionEnabled: isMentionEnabled,
    isVoiceMessageEnabled: isVoiceMessageEnabled,
    voiceRecord: voiceRecord,
    onUserProfileMessage: function onUserProfileMessage(channel) {
      setCurrentChannel(channel);
    },
    isTypingIndicatorEnabledOnChannelList: isTypingIndicatorEnabledOnChannelList,
    isMessageReceiptStatusEnabledOnChannelList: isMessageReceiptStatusEnabledOnChannelList,
    replyType: replyType,
    showSearchIcon: showSearchIcon,
    uikitOptions: uikitOptions
  }, /*#__PURE__*/React__default.createElement(AppLayout, {
    isReactionEnabled: isReactionEnabled,
    replyType: replyType,
    showSearchIcon: showSearchIcon,
    isMessageGroupingEnabled: isMessageGroupingEnabled,
    allowProfileEdit: allowProfileEdit,
    onProfileEditSuccess: onProfileEditSuccess,
    disableAutoSelect: disableAutoSelect,
    currentChannel: currentChannel,
    setCurrentChannel: setCurrentChannel
  }));
}
App.propTypes = {
  appId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  accessToken: PropTypes.string,
  customApiHost: PropTypes.string,
  customWebSocketHost: PropTypes.string,
  theme: PropTypes.string,
  userListQuery: PropTypes.func,
  nickname: PropTypes.string,
  profileUrl: PropTypes.string,
  breakpoint: PropTypes.oneOf([PropTypes.string, PropTypes.bool]),
  allowProfileEdit: PropTypes.bool,
  disableUserProfile: PropTypes.bool,
  disableMarkAsDelivered: PropTypes.bool,
  renderUserProfile: PropTypes.func,
  onProfileEditSuccess: PropTypes.func,
  dateLocale: PropTypes.shape({}),
  config: PropTypes.shape({
    // None Error Warning Info 'All/Debug'
    logLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    isREMUnitEnabled: PropTypes.bool
  }),
  uikitOptions: PropTypes.shape({}),
  isReactionEnabled: PropTypes.bool,
  replyType: PropTypes.oneOf(['NONE', 'QUOTE_REPLY', 'THREAD']),
  showSearchIcon: PropTypes.bool,
  isMessageGroupingEnabled: PropTypes.bool,
  stringSet: PropTypes.objectOf(PropTypes.string),
  colorSet: PropTypes.objectOf(PropTypes.string),
  imageCompression: PropTypes.shape({
    compressionRate: PropTypes.number,
    resizingWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    resizingHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  disableAutoSelect: PropTypes.bool,
  isMentionEnabled: PropTypes.bool,
  isVoiceMessageEnabled: PropTypes.bool,
  voiceRecord: PropTypes.shape({
    maxRecordingTime: PropTypes.number,
    minRecordingTime: PropTypes.number
  }),
  isTypingIndicatorEnabledOnChannelList: PropTypes.bool,
  isMessageReceiptStatusEnabledOnChannelList: PropTypes.bool
};
App.defaultProps = {
  accessToken: '',
  customApiHost: '',
  customWebSocketHost: '',
  theme: 'light',
  nickname: '',
  profileUrl: '',
  userListQuery: null,
  breakpoint: null,
  dateLocale: null,
  allowProfileEdit: false,
  onProfileEditSuccess: null,
  disableMarkAsDelivered: false,
  renderUserProfile: null,
  config: {},
  voiceRecord: {
    maxRecordingTime: VOICE_RECORDER_DEFAULT_MAX,
    minRecordingTime: VOICE_RECORDER_DEFAULT_MIN
  },
  isMessageGroupingEnabled: true,
  stringSet: null,
  colorSet: null,
  imageCompression: {},
  disableAutoSelect: false,
  uikitOptions: undefined,
  // The below configs are duplicates of the Dashboard UIKit Configs.
  // Since their default values will be set in the Sendbird component,
  // we don't need to set them here.
  showSearchIcon: undefined,
  isMentionEnabled: undefined,
  isReactionEnabled: undefined,
  replyType: undefined,
  disableUserProfile: undefined,
  isVoiceMessageEnabled: undefined,
  isTypingIndicatorEnabledOnChannelList: undefined,
  isMessageReceiptStatusEnabledOnChannelList: undefined
};
export { App as default };